(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/xpert-btn-selector/assets/javascripts/r-system-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/xpert-btn-selector/assets/javascripts/r-system-buttons.js');
"use strict";

const _React = React,
  useCallback = _React.useCallback;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const analytics = svs.components.analytics;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectHalfHedges = _svs$components$tipse.selectHalfHedges,
  selectFullHedges = _svs$components$tipse.selectFullHedges;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const CollapsibleButtonGroup = svs.components.tipsen.collapsibleGroup.CollapsibleButtonGroup;
const getSystemLabelFromNumber = svs.components.sport.systems.getSystemLabelFromNumber;
const XpertBtnRsys = _ref => {
  let setSize = _ref.setSize,
    size = _ref.size,
    xpertSystems = _ref.xpertSystems,
    _ref$isSystemDisabled = _ref.isSystemDisabled,
    isSystemDisabled = _ref$isSystemDisabled === void 0 ? () => false : _ref$isSystemDisabled;
  const couponId = useCouponId();
  const currentHalfHedges = useSelector(state => selectHalfHedges(state, couponId, 0));
  const currentFullHedges = useSelector(state => selectFullHedges(state, couponId, 0));
  const allSpecialValues = [];
  const trackEventOnSetSize = useCallback(selectedSize => {
    analytics.trackEvent({
      category: "Nya tipsen - Fyll i med PIX!",
      action: "\xD6nskat system - ".concat(selectedSize),
      opt_label: location.pathname
    });
  }, []);
  const isValueDisabled = useCallback(rSys => isSystemDisabled({
    currentHalfHedges,
    currentFullHedges,
    system: rSys
  }), [isSystemDisabled, currentFullHedges, currentHalfHedges]);
  const render = useCallback(rSys => getSystemLabelFromNumber(rSys), []);
  return React.createElement(CollapsibleButtonGroup, {
    allValues: xpertSystems,
    clickCallback: trackEventOnSetSize,
    isValueDisabled: isValueDisabled,
    promotedValues: allSpecialValues,
    render: render,
    setValue: setSize,
    title: "V\xE4lj system",
    value: size
  });
};
setGlobal('svs.components.tipsen.xpertenBtnSelector.XpertBtnRsys', XpertBtnRsys);

 })(window);